export const SET_LOADING = '@vms/SET_LOADING';
export const SAVE_DATA = '@vms/SAVE_DATA';
export const SET_FILTER = '@vms/SET_FILTER';
export const SET_ACTIVE_PAGE = '@vms/SET_ACTIVE_PAGE';
export const CITY_LOADING = '@vms/CITY_LOADING';
export const SET_CITY_OPTIONS = '@vms/SET_CITY_OPTIONS';
export const SET_CITY_SELECTED_OPTION = '@vms/SET_CITY_SELECTED_OPTION';
export const SAVE_VM_LIST_DATA = '@vms/SET_CITY_SELECTED_OPTION';
export const SAVE_VM_DETAILS_DATA = '@vms/SAVE_VM_DETAILS_DATA';


// WEBPACK FOOTER //
// ./src/Modules/VMs/constants.js